import {Injectable} from '@angular/core';
import {PageLayoutHandler} from '@spartacus/storefront';
import {combineLatest, Observable} from 'rxjs';
import {catchError, map, timeout} from 'rxjs/operators';
import {DcpActiveCartService} from '../services/dcp-active-cart.service';

const UNSTABLE_SPARTACUS_TIMEOUT: number = 2000;

@Injectable({
  providedIn: 'root',
})
export class CartLayoutHandlerService implements PageLayoutHandler {
  constructor(protected activeCartService: DcpActiveCartService) {}

  private getCombinedObservable(slots$: Observable<string[]>): Observable<any> {
    return combineLatest([
      slots$,
      this.activeCartService.requireLoadedCart().pipe(
        timeout(UNSTABLE_SPARTACUS_TIMEOUT),
        catchError(() => this.activeCartService.requireLoadedCart())
      ),
      this.activeCartService.getActiveCart(),
      this.activeCartService.getLoading(),
    ]);
  }

  handle(slots$: Observable<string[]>, pageTemplate?: string, section?: string) {
    if (pageTemplate === 'CartPageTemplate' && !section) {
      return this.getCombinedObservable(slots$).pipe(
        map(([slots, , cart]) => {
          const exclude: any = (arr, args) => arr.filter((item) => args.every((arg) => arg !== item));

          let filteredSlots;
          if (cart.totalItems === 0) {
            filteredSlots = exclude(slots, ['TopContent', 'CenterRightContentSlot', 'LoadingContent']);
          } else if (cart.totalItems) {
            filteredSlots = exclude(slots, ['EmptyCartMiddleContent', 'LoadingContent']);
          } else {
            filteredSlots = exclude(slots, ['TopContent', 'CenterRightContentSlot', 'EmptyCartMiddleContent']);
          }
          return filteredSlots;
        })
      );
    }
    return slots$;
  }
}
